import React from 'react';
import PropTypes from 'prop-types';

const EyeSlash = ({ onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M9.9297 3.69895C9.62449 3.66254 9.31437 3.64167 9.00001 3.63648C7.62634 3.6432 6.20236 4.01172 4.8545 4.71785C3.85372 5.26374 2.87885 6.0344 2.03223 6.98502C1.61643 7.4703 1.08575 8.17295 1 8.92262C1.01013 9.57204 1.64204 10.3736 2.03223 10.8603C2.82613 11.7735 3.77562 12.5221 4.8545 13.1274C4.89116 13.1471 4.92796 13.1665 4.96484 13.1856L3.96388 15.1135L5.32395 16L12.6762 1.88244L11.367 1L9.9297 3.69895ZM13.0342 4.66184L12.0352 6.57142C12.4948 7.22996 12.7676 8.04204 12.7676 8.92262C12.7676 11.1175 11.0806 12.8969 8.99902 12.8969C8.90903 12.8969 8.82182 12.8862 8.73339 12.8797L8.07226 14.142C8.37717 14.178 8.68546 14.2042 8.99999 14.2088C10.375 14.202 11.7981 13.8292 13.1445 13.1274C14.1453 12.5815 15.1211 11.8109 15.9678 10.8603C16.3836 10.375 16.9142 9.67233 17 8.92262C16.9899 8.27322 16.358 7.47167 15.9678 6.98501C15.1739 6.07172 14.2234 5.32312 13.1445 4.71782C13.1081 4.69835 13.0708 4.68084 13.0342 4.66184ZM8.99903 4.94834C9.09031 4.94834 9.18087 4.95237 9.27051 4.95911L8.4961 6.43788C7.40924 6.6809 6.59375 7.70078 6.59375 8.92156C6.59375 9.22823 6.64496 9.52182 6.73926 9.79395C6.73936 9.79426 6.73915 9.79473 6.73926 9.79504L5.96288 11.2781C5.5022 10.619 5.23046 9.80423 5.23046 8.92261C5.23047 6.72777 6.91744 4.94833 8.99903 4.94834ZM11.252 8.06638L9.50685 11.4009C10.5879 11.1533 11.3975 10.1381 11.3975 8.92156C11.3975 8.62049 11.343 8.33425 11.252 8.06638Z"
      fill="#6B6C7B"
    />
  </svg>
);

EyeSlash.propTypes = {
  onClick: PropTypes.func,
};

export default EyeSlash;
